import { graphql } from "@opensea/graphql"

export const FeaturedCollectionsCarouselFragment = graphql(`
  fragment CollectionOverviewFeaturedCollectionsCarousel on CollectionContentBlockModule {
    sections {
      __typename
      ... on FeatureContentBlock {
        collectionSlug
      }
    }
  }
`)
